import { Keyword } from 'common/services/keywords'

export interface KeywordsState {
  keywords: Keyword[]
}

const initialState: KeywordsState = {
  keywords: [],
}

// action types
const INIT = 'keywords/INIT'
const SET = 'keywords/SET'
const REMOVE = 'keywords/REMOVE'

// action creators
export const initKeywords = () => {
  return { type: INIT }
}

export const setKeywords = (keywords: Keyword[]) => {
  return { keywords, type: SET }
}

export const removeKeyword = (keyword: Keyword) => {
  return { keyword, type: REMOVE }
}

// reducer
export default (state: KeywordsState = initialState, action) => {
  switch (action.type) {
    case INIT:
      return { ...initialState }
    case SET:
      return { keywords: action.keywords }
    case REMOVE:
      return { keywords: getRemovedKeywordsBy(action.keyword, state.keywords) }
    default:
      return state
  }
}

const getRemovedKeywordsBy = (keyword: Keyword, keywords: Keyword[]) => keywords.filter(it => it._id !== keyword._id)
